import CameraAltIcon from "@mui/icons-material/CameraAlt";
import EditIcon from "@mui/icons-material/Edit";
import { Avatar, Badge, styled } from "@mui/material";
import React, { useRef } from "react";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 25,
  height: 25,
  border: `2px solid ${theme.palette.text.slateGray}`,
  cursor: "pointer",
}));

const ImageUploader = ({
  error,
  image,
  handleImageChange,
  canUpload = true,
}) => {
  const errorColor = error ? "text.errorRed" : "text.white";
  const fileInputRef = useRef(null);

  const handleAvatarClick = () => {
    if (canUpload) {
      fileInputRef.current.click();
    }
  };

  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      badgeContent={
        <SmallAvatar
          alt="Edit or Camera Icon"
          onClick={handleAvatarClick}
          sx={{
            border: `2px solid black`,
            borderColor: errorColor,
          }}
        >
          {image ? (
            <EditIcon sx={{ fontSize: "0.875rem", color: errorColor }} />
          ) : (
            <CameraAltIcon sx={{ fontSize: "0.875rem", color: errorColor }} />
          )}
        </SmallAvatar>
      }
    >
      <Avatar
        onClick={handleAvatarClick}
        src={image}
        sx={{
          height: 140,
          width: 140,
          border: `2px solid black`,
          borderColor: errorColor,
          cursor: "pointer",
        }}
      />
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          handleImageChange(e);
          fileInputRef.current.value = null;
        }}
      />
    </Badge>
  );
};

export default ImageUploader;
